module.exports = __webpack_public_path__ + "static/media/convex-hull.2c6ee79b.md";